module.exports = __webpack_public_path__ + "img/5@2x.b3b8da47.png";